export default __webpack_public_path__ + "static/media/icon-chat-image-dropdown.92e5ba27.svg";